import React, { useState, useEffect } from 'react';
import ClearIcon from '@material-ui/icons/Clear';
import { Typography, Button, IconButton, Grid, Box, TextField, Drawer } from "@material-ui/core";
import MUIDataTable from "mui-datatables";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { customTheme } from '../../../StyleComponents/Styledatatable';
import classNames from 'classnames';
import ApprovalIcon from '@mui/icons-material/Approval';
import FilterListIcon from '@mui/icons-material/FilterAlt';
import axios from "axios";
import Autocomplete from '@mui/material/Autocomplete';
import useStyles from '../../../StyleComponents/StyleFunctionComponent';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import Skeleton from '@material-ui/lab/Skeleton';
import LinearProgress from '@mui/material/LinearProgress';
import { API_BASE_URL, token, userLevel, adminId } from '../../../../constants';

const MonthlySocialCountReports = () => {
    const [openSidebar, setOpenSidebar] = useState(false);
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [perPage, setPerPage] = useState(50);
    const [page, setPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [selectedBrand, setSelectedBrand] = useState();
    const [brandOptions, setBrandOptions] = useState([]);

    const [selectedMonth, setSelectedMonth] = useState(() => {
        const currentMonth = new Date().getMonth() + 1;
        return monthOptions.find(item => item.id === currentMonth) || null;
    });

    const [selectedViewType, setSelectedViewType] = useState(() => {
        return viewTypeOptions.find(item => item.id === "month") || null;
    });
    const [activeViewType, setActiveViewType] = useState("month");

    const generateYearOptions = () => {
        const currentYear = new Date().getFullYear();
        const years = [];
        for (let i = currentYear; i >= currentYear - 10; i--) {
            years.push({ id: i, title: i.toString() });
        }
        return years;
    };
    const [yearOptions] = useState(generateYearOptions());
    const [selectedYear, setSelectedYear] = useState(() => {
        const years = generateYearOptions();
        return years.find(y => y.id === new Date().getFullYear()) || years[0];
    });
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');




    useEffect(() => {
        const fetchDatabrand = async () => {
            try {
                const config = {
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/json',
                        'Authorization': `${token}`,
                    },
                    timeout: Infinity,
                };
                const response = await axios.post(`${API_BASE_URL}/api/admin/v2/brand-list`, config);
                const statelist = response.data.data.map(item => ({
                    id: item.brand_id,
                    title: item.brand_name,
                }));
                setBrandOptions(statelist);
            } catch (error) {
                console.error('Error fetching state:', error);
            }
        };
        fetchDatabrand();
    }, []);

    const handleBrandChange = (event, newValue) => {
        setSelectedBrand(newValue);
    };
    const handleYearChange = (event, newValue) => {
        setSelectedYear(newValue);
    };

    const fetchData = async (filters = {}) => {
        setIsLoading(true);
        try {
            const brand = filters.brand !== undefined ? filters.brand : selectedBrand;
            const month = filters.month !== undefined ? filters.month : selectedMonth;
            const year = filters.year !== undefined ? filters.year : selectedYear;
            const viewTypeOption = filters.viewType !== undefined ? filters.viewType : selectedViewType;
            const requestedPage = filters.page !== undefined ? filters.page : page;
            const viewType = viewTypeOption?.id || "month";
            const config = {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    "Authorization": `${token}`,
                    "adminId": `${adminId}`,
                    "userLevel": `${userLevel}`,
                },
                timeout: Infinity,
            };
            const requestData = viewType === "month"
                ? { view_type: "month" }
                : {
                    brand_id: brand?.id || '',
                    page: requestedPage + 1,
                    pagination: perPage,
                    month: month?.id || '',
                    year: year?.id || '',
                    view_type: viewType,
                };
            const response = await axios.post(
                `${API_BASE_URL}/api/admin/v2/monthly-socialcount-reports`,
                requestData,
                config
            );
            const apiData = response.data.data;
            const responseRows = apiData.data || [];
            const mappedData = mapReportData(responseRows, viewType, requestedPage, perPage);

            setActiveViewType(viewType);
            setData(mappedData);
            setTotalCount(apiData.total || mappedData.length);
            const message = response.data.message;
            setSnackbarMessage(Array.isArray(message) ? message[0] : message || "Data fetched successfully");
            setSnackbarOpen(true);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    useEffect(() => {
        fetchData();
    }, [page, perPage]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (page === 0) {
            fetchData();
        } else {
            setPage(0);
        }
        setOpenSidebar(false);
    };
    const clearForm = () => {
        setSelectedMonth(null);
        setSelectedYear(null);
        setSelectedViewType(null);
        setSelectedBrand(null);
        if (page === 0) {
            fetchData({
                brand: null,
                month: null,
                year: null,
                viewType: null,
                page: 0,
            });
        } else {
            setPage(0);
        }
    };

    const monthColumns = [
        { name: "serial_number", label: "S/N" },
        { name: "year", label: "Year" },
        { name: "month", label: "Month" },
        { name: "total_leads", label: "Total Leads" },
        { name: "success_leads", label: "Success Leads" },
        { name: "duplicate_leads", label: "Duplicate Leads" },
        { name: "invalid_leads", label: "Invalid Leads" },
        { name: "month_name", label: "Month Name" },
        { name: "month_year", label: "Month Year" },
        { name: "duplicate_percentage", label: "Duplicate Percentage" },
    ];

    const campaignColumns = [
        { name: "serial_number", label: "S/N" },
        { name: "year", label: "Year" },
        { name: "month", label: "Month" },
        { name: "campaign_name", label: "Campaign Name" },
        { name: "total_leads", label: "Total Leads" },
        { name: "success_leads", label: "Success Leads" },
        { name: "duplicate_leads", label: "Duplicate Leads" },
        { name: "invalid_leads", label: "Invalid Leads" },
        { name: "month_name", label: "Month Name" },
        { name: "month_year", label: "Month Year" },
        { name: "duplicate_percentage", label: "Duplicate Percentage" },
    ];

    const brandColumns = [
        { name: "serial_number", label: "S/N" },
        { name: "year", label: "Year" },
        { name: "month", label: "Month" },
        { name: "brand_id", label: "Brand ID" },
        { name: "brand_name", label: "Brand Name" },
        { name: "total_leads", label: "Total Leads" },
        { name: "success_leads", label: "Success Leads" },
        { name: "duplicate_leads", label: "Duplicate Leads" },
        { name: "invalid_leads", label: "Invalid Leads" },
        { name: "month_name", label: "Month Name" },
        { name: "month_year", label: "Month Year" },
        { name: "duplicate_percentage", label: "Duplicate Percentage" },
    ];

    const columns = activeViewType === "campaign"
        ? campaignColumns
        : activeViewType === "brand"
            ? brandColumns
            : monthColumns;

    const CustomToolbarAction = () => (
        <IconButton aria-label="Filter list" onClick={toggleSidebar}>
            <FilterListIcon />
        </IconButton>
    );

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.shiftKey && event.key === 'F') {
                setOpenSidebar(true);
            }
        };
        window.addEventListener('keydown', handleKeyPress);
        return () => {
            window.removeEventListener('keydown', handleKeyPress);
        };
    }, []);

    const toggleSidebar = () => {
        setOpenSidebar(!openSidebar);
    };

    const options = {
        rowsPerPage: perPage,
        selectableRows: 'none',
        page: page,
        serverSide: true,
        count: totalCount,
        onTableChange: (action, tableState) => {
            switch (action) {
                case 'changePage':
                    setPage(tableState.page);
                    break;
                case 'changeRowsPerPage':
                    setPerPage(tableState.rowsPerPage);
                    setPage(0);
                    break;
                default:
                    break;
            }
        },
        customToolbar: () => <CustomToolbarAction />,
        filter: false,
        filterType: "dropdown",
        responsive: "standard",
        fixedHeader: true,
        fixedSelectColumn: true,
        overflowy: "auto",
        overflowx: "auto",
        rowsPerPageOptions: [10, 50, 100, 500, 1000, 10000, { value: totalCount, label: 'All' }],
    };
    const currentTheme = customTheme(true);
    const classes = useStyles();
    const handleCloseSnackbar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setSnackbarOpen(false);
    };

    const handleMonthChange = (event, newValue) => {
        setSelectedMonth(newValue);
    };

    const handleViewTypeChange = (event, newValue) => {
        setSelectedViewType(newValue);
    };


    return (
        <>
            <div>
                <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                    <MuiAlert onClose={handleCloseSnackbar} severity="info" sx={{ width: '100%' }}>
                        {snackbarMessage}
                    </MuiAlert>
                </Snackbar>
            </div>
            <Box sx={{ width: '100%' }}>
                <Typography className={classNames(classes.pagetittle, classes.pagetittlestyle)}>
                    Monthly Social Count Reports
                </Typography>
                <hr className={classes.horizontalline} />
            </Box>

            <MuiThemeProvider theme={currentTheme}>
                {
                    isLoading ? (
                        <LinearProgress />

                    ) : (
                        ""
                    )
                }

                <MUIDataTable
                    title={
                        isLoading ? (
                            <Skeleton animation="wave" />

                        ) : (
                            <Typography className={classes.tabletittle} >
                            </Typography>
                        )
                    }
                    data={data}
                    columns={columns}
                    options={options}
                />
            </MuiThemeProvider>
            <Drawer anchor="right" open={openSidebar}
                PaperProps={{
                    style: {
                        width: "100%",
                        maxWidth: 300,
                        padding: "10px"
                    }
                }}
                onClose={() => setOpenSidebar(false)}
            >
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={1}>
                        <Grid item xs={4} sm={2} lg={12} style={{ textAlign: "right", cursor: "pointer", }}>
                            <ClearIcon style={{ color: '#c0392b' }} onClick={() => setOpenSidebar(false)} />
                        </Grid>
                        <Grid item xs={4} sm={2} lg={12} >
                            <br />
                            <Typography className={classes.tabletittle} >
                                Filter
                            </Typography>
                        </Grid>
                    </Grid>
                    <div className={classes.root} style={{ paddingRight: "22px", paddingLeft: "22px" }}>
                        <div className={classes.root}>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={12} lg={12} >
                                    <Autocomplete
                                        classes={{
                                            option: classes.autocompleteoption,
                                        }}
                                        options={brandOptions}
                                        getOptionLabel={(option) => option.title}
                                        renderInput={(params) => (
                                            <TextField {...params} placeholder='Select brand' variant="outlined" />
                                        )}
                                        value={selectedBrand}
                                        onChange={handleBrandChange}
                                        disableCloseOnSelect
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        getOptionSelected={(option, value) => option.id === value.id}
                                        renderOption={(props, option, { selected }) => (
                                            <li {...props}>
                                                {option.title}
                                            </li>
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Autocomplete
                                        classes={{
                                            option: classes.autocompleteoption,
                                        }}
                                        options={yearOptions}
                                        getOptionLabel={(option) => option.title}
                                        value={selectedYear}
                                        onChange={handleYearChange}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        getOptionSelected={(option, value) => option.id === value.id}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder="Select Year"
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Autocomplete
                                        classes={{
                                            option: classes.autocompleteoption,
                                        }}
                                        options={monthOptions}
                                        getOptionLabel={(option) => option.title}
                                        value={selectedMonth}
                                        onChange={handleMonthChange}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        getOptionSelected={(option, value) => option.id === value.id}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder="Select Month"
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <Autocomplete
                                        classes={{
                                            option: classes.autocompleteoption,
                                        }}
                                        options={viewTypeOptions}
                                        getOptionLabel={(option) => option.title}
                                        value={selectedViewType}
                                        onChange={handleViewTypeChange}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        getOptionSelected={(option, value) => option.id === value.id}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                placeholder="Select View Type"
                                                variant="outlined"
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                    <br />
                    <Grid >

                        <Grid item xs={4} sm={2} lg={12} style={{ margin: "auto", padding: "auto", textAlign: "center" }}>
                            <Button
                                type='submit'
                                style={{ marginRight: "10px" }}
                                className={classes.buttonform}
                                variant="outlined" startIcon={<ApprovalIcon />}>
                                Apply
                            </Button>
                            <Button
                                type="button" onClick={clearForm}
                                style={{ backgroundColor: "#dc3545", borderColor: '#dc3545' }}
                                className={classes.buttonform}
                                variant="outlined" startIcon={<ClearIcon />}>
                                Clear
                            </Button>
                        </Grid>
                    </Grid>
                    <br />
                </form>
            </Drawer >
        </>
    );
};

export default MonthlySocialCountReports;

const mapReportData = (rows, viewType, page, perPage) => {
    return rows.map((item, index) => {
        const mappedItem = {
            serial_number: page * perPage + index + 1,
            year: item.year ?? "",
            month: item.month ?? "",
            total_leads: item.total_leads ?? "",
            success_leads: item.success_leads ?? "",
            duplicate_leads: item.duplicate_leads ?? "",
            invalid_leads: item.invalid_leads ?? "",
            month_name: item.month_name || "",
            month_year: item.month_year || "",
            duplicate_percentage: item.duplicate_percentage ?? "",
        };

        if (viewType === "month") {
            return mappedItem;
        }

        if (viewType === "campaign") {
            return {
                ...mappedItem,
                campaign_name: item.campaign_name || "",
            };
        }

        return {
            ...mappedItem,
            brand_id: item.brand_id ?? "",
            brand_name: item.brand_name || "",
        };
    });
};

const monthOptions = [
    { id: 1, title: "January" },
    { id: 2, title: "February" },
    { id: 3, title: "March" },
    { id: 4, title: "April" },
    { id: 5, title: "May" },
    { id: 6, title: "June" },
    { id: 7, title: "July" },
    { id: 8, title: "August" },
    { id: 9, title: "September" },
    { id: 10, title: "October" },
    { id: 11, title: "November" },
    { id: 12, title: "December" },
];


const viewTypeOptions = [
    { id: "month", title: "Month" },
    { id: "campaign", title: "Campaign" },
    { id: "brand", title: "Brand" },
];
